import React from 'react';
import { Dialog, Classes } from '@blueprintjs/core';
// components
import { Button, Icons } from '../';
import cx from 'classnames';
// constants
import { prefix } from '../../constants';
export const Modal = ({ autoFocus = true, canEscapeKeyClose = true, canOutsideClickClose = true, enforceFocus = true, isOpen = false, usePortal = true, title, translationData = {
    cancel: 'Cancel',
    update: 'Update',
    closeModal: 'Close Modal',
    resetToDefault: 'Reset to default',
}, className, handleUpdate = () => { }, handleReset = () => { }, handleModalClose = () => { }, children, }) => {
    return (React.createElement(Dialog, { className: cx(className, `${prefix}-modal`), autoFocus: autoFocus, canEscapeKeyClose: canEscapeKeyClose, canOutsideClickClose: canOutsideClickClose, enforceFocus: enforceFocus, isOpen: isOpen, usePortal: usePortal, onClose: handleModalClose },
        title && (React.createElement("div", { className: Classes.DIALOG_HEADER },
            React.createElement("h4", { className: Classes.HEADING }, title),
            React.createElement(Button, { onClick: handleModalClose, className: Classes.DIALOG_CLOSE_BUTTON, style: "subtle", leftIcon: React.createElement(Icons, { size: 25, iconName: "ic-ui-cancel" }), iconOnly: true, "aria-label": translationData.closeModal }))),
        React.createElement("div", { className: Classes.DIALOG_BODY }, children),
        React.createElement("div", { className: Classes.DIALOG_FOOTER },
            React.createElement("div", { className: "reset" },
                React.createElement("a", { className: "subtle-link", onClick: handleReset }, translationData.resetToDefault)),
            React.createElement("div", { className: Classes.DIALOG_FOOTER_ACTIONS },
                React.createElement(Button, { style: "subtle", onClick: handleModalClose }, translationData.cancel),
                React.createElement(Button, { style: "primary", size: "m", onClick: handleUpdate }, translationData.update)))));
};
//# sourceMappingURL=Modal.js.map